import { useEffect, useRef } from "react";

// Ejecuta cb() al montar, cada `ms` y al volver a la app (visibilitychange).
export function usePolling(cb, ms = 30000) {
  const cbRef = useRef(cb);
  cbRef.current = cb;
  useEffect(() => {
    const tick = () => cbRef.current();
    tick();
    const id = setInterval(tick, ms);
    const onVis = () => {
      if (document.visibilityState === "visible") tick();
    };
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("leonas:idioma", tick); // al cambiar el idioma se vuelve a pedir lo que arma el servidor
    return () => {
      window.removeEventListener("leonas:idioma", tick);
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [ms]);
}
